import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { LinkTarget } from "../../utilities/helpers/linkTarget";
import { AccessLink } from "../AccessLink/AccessLink";
import { zoneColourStyle } from "./ZoneChip";
import { ZoneLabel, ZoneTooltip } from "./ZoneTooltip";

/** A table cell naming a machine in its zone's colour, linking on only when the user may follow it. */
export function ZoneMachineCell({ name, zone, target = null }: {
  name: string;
  zone?: ZoneLabel;
  target?: LinkTarget | null;
}) {
  return (
    <ZoneTooltip zone={zone}>
      <AccessLink
        target={target}
        newTab
        className="relative flex items-center justify-center gap-1 p-1 h-full w-full font-bold shadow border border-theme-table-heading-border rounded group"
        style={zone && zoneColourStyle(zone.hexColour)}
        linkedAdornment={<FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-[8px] absolute top-1 right-1 group-hover:translate-x-[2px] opacity-70 group-hover:opacity-100 transition" />}
      >
        {name}
      </AccessLink>
    </ZoneTooltip>
  );
}
